import spectralData from "./raw/spectral.json";
import spectralDataInterval from "./raw/spectral_in.json";

export const SpectralColorMap = (type) => {
  if (type === "interval") {
    return spectralDataInterval;
  }
  if (type === "range") {
    return spectralData;
  }
};
